__turbopack_context__.v({
  "accordionContent": "mobile-theme-toggle-module__EYwmsW__accordionContent",
  "accordionHeader": "mobile-theme-toggle-module__EYwmsW__accordionHeader",
  "accordionItem": "mobile-theme-toggle-module__EYwmsW__accordionItem",
  "accordionRoot": "mobile-theme-toggle-module__EYwmsW__accordionRoot",
  "accordionTrigger": "mobile-theme-toggle-module__EYwmsW__accordionTrigger",
  "accordionTriggerContainer": "mobile-theme-toggle-module__EYwmsW__accordionTriggerContainer",
  "caretIcon": "mobile-theme-toggle-module__EYwmsW__caretIcon",
  "currentTheme": "mobile-theme-toggle-module__EYwmsW__currentTheme",
  "currentThemeIcon": "mobile-theme-toggle-module__EYwmsW__currentThemeIcon",
  "currentThemeLabel": "mobile-theme-toggle-module__EYwmsW__currentThemeLabel",
  "edit": "mobile-theme-toggle-module__EYwmsW__edit",
  "optionIcon": "mobile-theme-toggle-module__EYwmsW__optionIcon",
  "optionLabel": "mobile-theme-toggle-module__EYwmsW__optionLabel",
  "themeOption": "mobile-theme-toggle-module__EYwmsW__themeOption",
  "themeOptionActive": "mobile-theme-toggle-module__EYwmsW__themeOptionActive",
  "themeOptions": "mobile-theme-toggle-module__EYwmsW__themeOptions",
  "triggerContent": "mobile-theme-toggle-module__EYwmsW__triggerContent",
  "triggerLabel": "mobile-theme-toggle-module__EYwmsW__triggerLabel",
});
